import type { DefectLayerKind, DefectLayerPresentation } from '../contracts/availableLayers';

/** Presentation kinds for street and overview defect overlays. */
export type DefectOverlayPresentation =
  | 'crackmap'
  | 'pothole'
  | 'line-condition';

export type DefectOverlayLayerKind = DefectOverlayPresentation;

const OVERLAY_PRESENTATIONS: ReadonlySet<string> = new Set([
  'crackmap',
  'pothole',
  'line-condition',
]);

export function isDefectOverlayPresentation(
  value: DefectLayerPresentation | string | null | undefined,
): value is DefectOverlayPresentation {
  return typeof value === 'string' && OVERLAY_PRESENTATIONS.has(value);
}

export function isDefectOverlayLayerKind(
  value: DefectLayerKind | string | null | undefined,
): value is DefectOverlayLayerKind {
  return isDefectOverlayPresentation(value);
}

export function toDefectOverlayLayerKind(
  presentation: DefectLayerPresentation | undefined,
): DefectLayerKind {
  if (isDefectOverlayPresentation(presentation)) {
    return presentation;
  }
  return 'map-vector';
}
